<!--
 Copyright 2022 by DomX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of DomX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-overlay :value="modalName">
    <component
      :is="modalName"
      :payload="modalPayload"/>
  </v-overlay>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import LogOutModal from './Modals/LogOutModal.vue'
import AddClientModal from '@/components/Modals/Clients/AddClientModal.vue'
import DeleteClientModal from '@/components/Modals/Clients/DeleteClientModal.vue'
import EditClientModal from '@/components/Modals/Clients/EditClientModal.vue'
import AddInstallationModal from '@/components/Modals/Installations/AddInstallationModal.vue'
import DeleteInstallationModal from '@/components/Modals/Installations/DeleteInstallationModal.vue'
import EditInstallationModal from '@/components/Modals/Installations/EditInstallationModal.vue'
import AddDeviceModal from '@/components/Modals/Devices/AddDeviceModal.vue'
import DeleteDeviceModal from '@/components/Modals/Devices/DeleteDeviceModal.vue'
import EditDeviceModal from '@/components/Modals/Devices/EditDeviceModal.vue'
import EditInventoryDeviceModal from '@/components/Modals/Devices/EditInventoryDeviceModal.vue'
import ExportDeviceDataModal from '@/components/Modals/Devices/ExportDeviceDataModal.vue'


import { commonModule } from '@/store/modules/store-accessor'

@Component({
  components: {
    LogOutModal,
    DeleteInstallationModal,
    AddClientModal,
    DeleteClientModal,
    EditClientModal,
    AddInstallationModal,
    EditInstallationModal,
    AddDeviceModal,
    DeleteDeviceModal,
    EditDeviceModal,
    EditInventoryDeviceModal,
    ExportDeviceDataModal
  }
})
export default class TheModal extends Vue {
  get modalName () {
    return commonModule.modal.name
  }

  get modalPayload () {
    return commonModule.modal.payload
  }
};
</script>
